module.exports = __webpack_public_path__ + "img/symbol_3.7b34a5c5.png";